import { useEffect } from "react";
import { useLocation } from "react-router-dom";
const titles = [
    [/^\/admin\/login$/, "售后服务呼叫管理端登录"],
    [/^\/admin\/users/, "用户管理 - 售后服务呼叫管理端"],
    [/^\/admin\/numbers/, "电话管理 - 售后服务呼叫管理端"],
    [/^\/admin\/calls/, "呼叫记录 - 售后服务呼叫管理端"],
    [/^\/admin\/settings/, "系统配置 - 售后服务呼叫管理端"],
    [/^\/admin/, "售后服务呼叫管理端"],
    [/^\/login$/, "售后服务呼叫用户端登录"],
    [/^\/app\/history/, "请求记录 - 售后服务呼叫用户端"],
    [/^\/app/, "售后服务呼叫用户端"]
];
export function PageTitle() {
    const location = useLocation();
    useEffect(() => {
        document.title = titles.find(([pattern]) => pattern.test(location.pathname))?.[1] ?? "售后服务呼叫";
    }, [location.pathname]);
    return null;
}
